import OverlappingItems from 'common/components/overlappingItems/OverlappingItems'
import { formatDistributionChannel } from 'common/distributionChannelUtils'
import { IconType } from 'common/icons/Icon'
import { DistributionChannel } from 'common/interfaces/projects'

import { getIconForDistributionChannel } from '../channelPicker/ChannelPicker'

interface Props {
  distributionChannels: DistributionChannel[]
}

const DistributionChannelIconList = ({ distributionChannels }: Props) => {
  return distributionChannels.length > 0 ? (
    <OverlappingItems
      size="small"
      itemNames={distributionChannels.map((distributionChannel) => {
        return formatDistributionChannel(distributionChannel)
      })}
      items={distributionChannels.map((distributionChannel, key) => {
        const Icon: IconType | undefined =
          getIconForDistributionChannel(distributionChannel)
        return Icon ? (
          <Icon
            key={key}
            className="p-3 w-12 h-12 rounded-full bg-gold-300 border-white border-1"
          />
        ) : null
      })}
    />
  ) : null
}

export default DistributionChannelIconList
